import type { LayoutPattern, Side } from "@el/schema";

/** 画面と PDF で使う語（docs/screens.md 1 章の用語表） */
export const PATTERN_LABEL: Record<LayoutPattern, string> = { line: "直線", L: "L字", U: "U字", ko: "コの字", auto: "自動" };
export const PATTERN_ORDER: LayoutPattern[] = ["line", "L", "U", "ko", "auto"];

export const PROPOSAL_STATUS_LABEL = { draft: "作成中", presented: "提示済み", won: "受注", lost: "失注" } as const;
export type ProposalStatusKey = keyof typeof PROPOSAL_STATUS_LABEL;

export const SIDE_LABEL: Record<Side, string> = { left: "左", right: "右", front: "前", back: "後ろ" };
export const CATEGORY_LABEL = { equipment: "設備", conveyor: "搬送", auxiliary: "付帯" } as const;
export const CHECK_STATUS_LABEL = { ai: "AI 読み取り", partial: "一部確認済み", checked: "確認済み", manual: "手入力" } as const;

export const IMPORT_STATUS_LABEL = { queued: "待機中", extracting: "読み取り中", done: "完了", failed: "失敗" } as const;
export const IMPORT_SOURCE_LABEL = { excel: "Excel", csv: "CSV", pdf: "PDF", image: "画像", url: "製品ページ" } as const;

export const AI_FEATURE_LABEL = { ocr: "資料の読み取り（OCR）", text: "文章で要望・項目の対応", embedding: "類似の提案の検索", reread: "読み直し" } as const;
export const AI_PROVIDER_LABEL = { gemini: "Gemini", openai: "OpenAI" } as const;

export const ISSUE_LABEL = {
  outside: "はみ出し",
  overlap: "干渉",
  clearance: "空きの重なり",
  obstacle: "柱・既存設備との干渉",
  aisle: "通路が足りない",
  door: "扉の前をふさいでいる",
  size_unknown: "寸法が未設定",
} as const;

/** 版の表示名。番号はサーバーが同期時に決める */
export function revisionLabel(label: string | null): string {
  return label ? `第${label}版` : "未同期の版";
}

/** 製品の値の項目名 */
export const FIELD_LABEL: Record<string, string> = {
  code: "製品コード",
  name: "名称",
  modelNo: "型式",
  widthMm: "幅（流れ方向）",
  depthMm: "奥行",
  heightMm: "高さ",
  listPrice: "販売価格",
  costPrice: "原価",
  installCost: "据付費",
  weightKg: "質量",
  powerKw: "電力",
  sourceUrl: "製品ページ URL",
  makerId: "メーカー",
  clearance: "空き",
};

export const PRODUCT_NAME = "設備レイアウト・概算見積";
